import http from '@utils/http';
import {geturlParams} from '@utils/index';

let isteacherApp = geturlParams()["Api-Version"]

let base = {
  fat: 'https://teacherapi-test.zmlearn.com/v1/teacherApp/app',
  dev: 'https://teacherapi-test.zmlearn.com/v1/teacherApp/app',
  prod: 'https://teacherapi.zmlearn.com/v1/teacherApp/app',
} [process.env.VUE_APP_RUN_ENV]

export function hasPassword(params) {
  return isteacherApp ? http.post(base + '/api/pay/h5/salary/hasPassword', params) : http.post('/api/pay/h5/salary/hasPassword', params);
}

export function codeSend(params) {
  return isteacherApp ? http.post(base + '/api/pay/h5/salary/codeSend', params) : http.post('/api/pay/h5/salary/codeSend', params);

}

export function salaryQueryPassword(params) {
  return isteacherApp ? http.post(base + '/api/pay/h5/salary/insertOrUpdate/salaryQueryPassword', params) : http.post('/api/pay/h5/salary/insertOrUpdate/salaryQueryPassword', params);
}

export function querySalary(params) {
  return isteacherApp ? http.post(base + '/api/pay/h5/salary/querySalary', params) : http.post('/api/pay/h5/salary/querySalary', params);

}

export function querySalaryConfigDescription(params) {
  return isteacherApp ? http.post(base + '/api/pay/h5/salary/querySalaryConfigDescription', params) : http.post('/api/pay/h5/salary/querySalaryConfigDescription', params);

}
